import navbarSearchAndPinList from "@/layouts/components/navbarSearchAndPinList";
import whitelabel from "@/whitelabel";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    isSidebarActive: true,
    breakpoint: null,
    sidebarWidth: "default",
    reduceButton: whitelabel.config.sidebarCollapsed,
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: whitelabel.config.theme || "light",
    navbarSearchAndPinList: navbarSearchAndPinList,
    AppActiveUser: {
      id: 0,
      name: "John Doe",
      about:
        "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
      img: "avatar-s-11.png",
      status: "online"
    },

    notify: false,

    themePrimaryColor: whitelabel.colors.primary,

    starredPages: navbarSearchAndPinList.data.filter(
      page => page.highlightAction
    ),
    userRole: null,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar component
    windowWidth: null
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    UPDATE_SIDEBAR_WIDTH(state, width) {
      state.sidebarWidth = width;
    },
    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
      state.sidebarItemsMin = val;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
      state.reduceButton = val;
    },
    TOGGLE_CONTENT_OVERLAY(state, val) {
      state.bodyOverlay = val;
    },
    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
      state.isSidebarActive = value;
    },
    UPDATE_THEME(state, val) {
      state.theme = val;
    },
    UPDATE_WINDOW_BREAKPOINT(state, val) {
      state.breakpoint = val;
    },
    UPDATE_PRIMARY_COLOR(state, val) {
      state.themePrimaryColor = val;
    },
    UPDATE_WINDOW_WIDTH(state, width) {
      state.windowWidth = width;
    },

    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    UPDATE_STARRED_PAGE(state, payload) {
      // find item index in search list state
      const index = state.navbarSearchAndPinList.data.findIndex(
        item => item.index == payload.index
      );
      // update the main list
      state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

      // if val is true add it to starred else remove
      if (payload.val) {
        state.starredPages.push(state.navbarSearchAndPinList.data[index]);
      } else {
        // find item index from starred pages
        const index = state.starredPages.findIndex(
          item => item.index == payload.index
        );
        // remove item using index
        state.starredPages.splice(index, 1);
      }
    },

    // The Navbar
    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
      const starredPagesMore = state.starredPages.slice(10);
      state.starredPages = list.concat(starredPagesMore);
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
      let downToUp = false;
      let lastItemInStarredLimited = state.starredPages[10];
      const starredPagesLimited = state.starredPages.slice(0, 10);
      state.starredPages = starredPagesLimited.concat(list);

      state.starredPages.slice(0, 10).map(i => {
        if (list.indexOf(i) > -1) downToUp = true;
      });
      if (!downToUp) {
        state.starredPages.splice(10, 0, lastItemInStarredLimited);
      }
    },

    // Notification Alert
    SHOW_NOTIFICATION(state, data) {
      state.notify = data;
    },

    // Notification Alert
    SET_DUSK_TEST(state, data) {
      state.dusk = true;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {},

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    updateSidebarWidth({ commit }, width) {
      commit("UPDATE_SIDEBAR_WIDTH", width);
    },
    toggleContentOverlay({ commit }) {
      commit("TOGGLE_CONTENT_OVERLAY");
    },
    updateTheme({ commit }, val) {
      commit("UPDATE_THEME", val);
    },
    updateWindowWidth({ commit }, width) {
      commit("UPDATE_WINDOW_WIDTH", width);
    },

    // ////////////////////////////////////////////
    // COMPONENT
    // ////////////////////////////////////////////

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit("UPDATE_STARRED_PAGE", payload);
    },

    //  The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit("ARRANGE_STARRED_PAGES_LIMITED", list);
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit("ARRANGE_STARRED_PAGES_MORE", list);
    },

    //  Notification Alert
    showNotification({ commit }, data) {
      commit("SHOW_NOTIFICATION", data);
    },

    //  Reset Loadings
    resetLoading({ commit }) {
      commit("SET_ASSOCIACAO_LOADING", false);
      commit("SET_BENEFICIARIOS_LOADING", false);
      commit("SET_CIDADES_LOADING", false);
      commit("SET_ENTIDADES_LOADING", false);
      commit("SET_ESPECIE_BENEFICIO_LOADING", false);
      commit("SET_ESTADOS_LOADING", false);
      commit("SET_ESTADOS_CIVIS_LOADING", false);
      commit("SET_FORMA_PAGAMENTO_LOADING", false);
      commit("SET_LOGIN_LOADING", false);
      commit("SET_SEXOS_LOADING", false);
      commit("SET_STATUS_LOADING", false);
      commit("SET_STATUS_AGRUPADO_LOADING", false);
      commit("SET_STATUS_MOTIVO_LOADING", false);
      commit("SET_TIPO_USUARIO_LOADING", false);
      commit("SET_USUARIOS_LOADING", false);
      commit("SET_TIPO_CONTRATO_LOADING", false);
    }
  }
};

export default store;
